import { Component } from "@angular/core";

@Component({
  selector: "pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["../../styles.marketing247.css"],
})
export class PricingComponent {}
